module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"all-rights":"© 2018. All RIGHT RESERVED.","catch-phrase":"To the moon","logo-by":"Logo by"},"fr_FR":{"all-rights":"© 2018. TOUS DROITS RÉSERVÉS.","catch-phrase":"Direction la Lune","logo-by":"Logo réalisé par "}}')
  delete Component.options._Ctor
}
